import MenuItem from './../entities/menuItem';
import _includes from 'lodash/includes';
/**
 * @desc  MenuItemService class.
 * @ngInject
 */
export default class MenuItemService {
  /**
   * Constructor of the class.
   *
   * @param {ui.router.state.$state}  $state
   * @param {$mdSidenav}              $mdSidenav
   * @param {$log}                    $log
   */
  constructor(
    $state, $mdSidenav, $log,
    modules,
    SchoolCommonRoomService
  ) {
    this.$state = $state;
    this.$mdSidenav = $mdSidenav;
    this.$log = $log;
    this.modules = modules;
    this.SchoolCommonRoomService = SchoolCommonRoomService;
  }

  getItems() {
    return this.SchoolCommonRoomService.getMe()
      .then(({roleName}) => {
        return this.modules
          .filter(item => _includes(item.permissions, 'ALL') || _includes(item.permissions, roleName))
          .filter(item => item.showInMenu)
          .map(item => new MenuItem(item));
      });
  }

  /**
   * Method to change application state to another one.
   *
   * @param {Object}    [params]
   * @returns {promise}
   */
  goToPage(item, params = {}) {
    const parameters = (Object.is({}, params) && !Object.is({}, item.params)) ? item.params : params;

    return this.$state.go(item.state, parameters);
  }

  isActive(item) {
    return (this.$state.current.name === item.state);
  }
}
